import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

export default class extends Component {
  static propTypes = {
    title: PropTypes.string.isRequired,
    children: PropTypes.any,
    dataTestId: PropTypes.string,
  };

  constructor(props) {
    super(props);
    this.state = {
      open: true,
    };
  }

  handleToggleSection = () => this.setState({ open: !this.state.open });
  render() {
    const { title, children, dataTestId } = this.props;

    const { open } = this.state;
    const toggleClassName = classnames({
      fa: true,
      'mr-0': true,
      'font-light': true,
      'fa-chevron-right': !open,
      'fa-chevron-down': open,
    });

    const filtersClassName = classnames({
      'filters-list': true,
      'px-4': true,
      'pb-4': true,
      hide: !open,
      'border-b': true,
      'border-grey-light': true,
      'border-solid': true,
    });
    return (
      <div data-testid={dataTestId} className="list-filter-group">
        <div
          data-testid="div-52cda722"
          className="heading flex justify-between pt-4 items-center"
        >
          <h4 data-testid="h4-e38f30ab" className="text-black text-sm m-0 pl-4">
            {title}
          </h4>
          <button
            data-testid="button-0d0dd087"
            className="button"
            onClick={this.handleToggleSection}
          >
            <span data-testid="span-670a9124" className={toggleClassName} />
          </button>
        </div>
        <div data-testid="div-43ccb11e" className={filtersClassName}>
          {children}
        </div>
      </div>
    );
  }
}
